import React from 'react';
import ReactDom from 'react-dom';
import Routes from './routes';
import './index.css';

const MOUNT = document.getElementById('root');
const renderApp = (Comp) => ReactDom.render(Comp, MOUNT);

if (module.hot) {
  module.hot.accept('./routes', () => {
    // accept hot change request.
    const NextRoutes = require('./routes').default;
    renderApp(<NextRoutes />);
  });
}

renderApp(<Routes />);
